import styled, { createGlobalStyle } from "styled-components";

// ─── Design Tokens ───────────────────────────────────────────────────────────
export const theme = {
  colors: {
    primary: "#F47E1F",
    secondary: "#134ddc",
    secondaryContainer: "#3b69f6",
    surface: "#fbf8ff",
    surfaceContainerHighest: "#e0e0fb",
    onSurface: "#181a2d",
    onSurfaceVariant: "#524534",
    onPrimary: "#ffffff",
    onSecondary: "#ffffff",
    outline: "#857462",
    outlineVariant: "#d7c3ae",
  },
  fonts: {
    body: "'Inter', sans-serif",
  },
  radii: {
    sm: "0.5rem",
    md: "1rem",
    lg: "2rem",
    xl: "3rem",
    full: "9999px",
  },
};

// ─── Global Styles ────────────────────────────────────────────────────────────
export const GlobalStyle = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html, body, #root {
    height: 100%;
    font-family: ${theme.fonts.body};
    background-color: ${theme.colors.surface};
    color: ${theme.colors.onSurface};
    overflow: hidden;
  }
`;

// ─── Layout ───────────────────────────────────────────────────────────────────
export const PageWrapper = styled.main`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  overflow: hidden;
  height: 100%;
`;

export const ContentCard = styled.div`
  width: 100%;
  max-width: 28rem;
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
  justify-content: space-between;
`;

// ─── Top Section ──────────────────────────────────────────────────────────────
export const TopSection = styled.div`
  text-align: center;
  width: 100%;
  padding-top: 1rem;
`;

export const LogoWrapper = styled.div`
  margin-bottom: 1.5rem;
`;

export const Logo = styled.img`
  height: 3rem;
  width: auto;
  margin: 0 auto;
  object-fit: contain;
  display: block;
`;

export const InvitationBadge = styled.span`
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: ${theme.radii.full};
  background-color: ${theme.colors.secondary};
  color: ${theme.colors.onSecondary};
  font-size: 0.625rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-bottom: 1rem;
`;

export const Headline = styled.h2`
  font-size: 1.875rem;
  font-weight: 900;
  line-height: 1.2;
  letter-spacing: -0.03em;
  color: ${theme.colors.onSurface};
  margin-bottom: 0.5rem;
`;

export const HeadlineAccent = styled.span`
  color: ${theme.colors.primary};
`;

export const SubText = styled.p`
  font-size: 0.875rem;
  line-height: 1.6;
  color: ${theme.colors.onSurfaceVariant};
  padding: 0 1rem;
`;

// ─── Hero Image Section ───────────────────────────────────────────────────────
export const HeroSection = styled.div`
  position: relative;
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 0;
  padding: 1rem 0;
`;

export const HeroInner = styled.div`
  position: relative;
  width: 100%;
  max-width: 24rem;
  margin: 0 auto;
`;

export const GlowBlob = styled.div`
  position: absolute;
  inset: 0;
  background: ${theme.colors.primary}1a; /* ~10% opacity */
  border-radius: ${theme.radii.full};
  filter: blur(3rem);
  z-index: -1;
`;

export const ImageFrame = styled.div`
  width: 70%;
  overflow: hidden;
  border-radius: ${theme.radii.lg};
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.12);
  aspect-ratio: 1 / 1;
  display: flex;
  margin: auto;
  align-items: center;
  justify-content: center;
  align-items: center;
  justify-content: center;  background-color: #ffffff;
  border: 1px solid ${theme.colors.surfaceContainerHighest};
`;

export const RingImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 2rem;
`;

// ─── CTA Button ───────────────────────────────────────────────────────────────
export const SignUpButton = styled.button`
  width: 100%;
  background-color: ${theme.colors.primary};
  color: ${theme.colors.onPrimary};
  font-weight: 700;
  font-size: 1.125rem;
  padding: 1rem 0;
  border-radius: ${theme.radii.full};
  border: none;
  cursor: pointer;
  box-shadow: 0 10px 30px rgba(244, 126, 31, 0.35);
  transition: transform 0.15s ease;
 
  &:active {
    transform: scale(0.98);
  }
`;